import { Avatar as MuiAvatar, Box, styled } from '@mui/material';

export const Wrapper = styled(Box)`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Avatar = styled(MuiAvatar)`
  width: 60;
  height: 60;
  margin: 4px;
  background-color: ${({ theme }) => theme.palette.primary.main};
`;

export const ButtonWrapper = styled(Box)`
  margin-top: 12px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;
